import React, { useState } from "react";
import { Row, Col } from "react-bootstrap";
import { graphql } from "gatsby";
import Fade from "react-reveal/Fade";
import Img from "gatsby-image";
import Layout from "../../../components/Common/Layout";
import CompanyLogo from "../../../components/Website/TrustUs/CompanyLogo";
import ProjectsNavigation from "../../../components/Website/ProjectsNavigation";
import ServicePellet from "../../../components/Website/ServicePellet";
import ProjectImagesSwiper from "../../../components/Website/ProjectImagesSwiper";


const BestSeller = ({ data }) => {
  const [modalVisible, setModalVisible] = useState(false);

  const imagesData = data.allFile.edges.map(
    (edge) => edge.node.childImageSharp.fluid
  );

  return (
    <Layout
      modalVisible={modalVisible}
      setModalVisible={setModalVisible}
      selectedLanguage="pt"
      title="Brocode Studio || Bestseller"
      description="Bestseller é uma marca de moda com mais de 20 marcas
      distribuídas em todo o mundo."
    >
      <div className="project-page">
        <div className="brocode-content">
          <Row className="bk-about-area">
            <Col md={6} xs={12}>
              <Fade bottom duration={2000}>
                {" "}
                <div className="content">
                  <div className="title wow move-up mb--10">
                    <h2>BestSeller App</h2>
                  </div>
                  <ServicePellet service="UI & UX" />
                  <Row className="my-md-4 my-1 d-md-block d-none mx-0">
                    <p className="wow move-up mb--20">
                      Bestseller é uma marca de moda com mais de 20 marcas
                      distribuídas em todo o mundo.
                    </p>
                    <p className="wow move-up mb--20">
                      Neste aplicativo de comércio eletrônico, os usuários podem
                      comprar várias marcas como JACK & JONES, VERO MODA, ONLY,
                      NAME IT, SELECTED e muito mais.
                    </p>
                  </Row>
                </div>
              </Fade>
            </Col>
            <Col md={6} xs={12}>
              <Img fluid={imagesData[9]} />
            </Col>
          </Row>
          <Fade bottom duration={2000}>
            <Row className="my-md-4 my-1 d-md-none d-block mx-0">
              <p className="wow move-up mb--20">
                Bestseller é uma marca de moda com mais de 20 marcas
                distribuídas em todo o mundo.
              </p>
              <p className="wow move-up mb--20">
                Neste aplicativo de comércio eletrônico, os usuários podem
                comprar várias marcas como JACK & JONES, VERO MODA, ONLY, NAME
                IT, SELECTED e muito mais.
              </p>
            </Row>
          </Fade>
          <Fade bottom duration={2000}>
            {" "}
            <Row className="my-4  d-none d-md-flex">
              <Col md={4} xs={12}>
                <Img fluid={imagesData[0]} />
              </Col>
              <Col md={4} xs={12}>
                <Img fluid={imagesData[1]} />
              </Col>
              <Col md={4} xs={12}>
                <Img fluid={imagesData[2]} />
              </Col>
            </Row>
            <ProjectImagesSwiper
              imagesList={imagesData.filter((img, id) => id !== 9)}
            />
          </Fade>
          <Fade bottom duration={2000}>
            {" "}
            <Row className="my-4  d-none d-md-flex">
              <Col md={4} xs={12}>
                <Img fluid={imagesData[3]} />
              </Col>
              <Col md={4} xs={12}>
                <Img fluid={imagesData[4]} />
              </Col>
              <Col md={4} xs={12}>
                <Img fluid={imagesData[5]} />
              </Col>
            </Row>
          </Fade>
          <Fade bottom duration={2000}>
            <Row className="my-4  d-none d-md-flex">
              <Col md={4} xs={12}>
                <Img fluid={imagesData[6]} />
              </Col>
              <Col md={4} xs={12}>
                <Img fluid={imagesData[7]} />
              </Col>
              <Col md={4} xs={12}>
                <Img fluid={imagesData[8]} />
              </Col>
            </Row>
          </Fade>

          <Fade bottom duration={2000}>
            <Row className="justify-content-center">
              <CompanyLogo name="bestseller" />
            </Row>
          </Fade>

          <ProjectsNavigation
            nextProject={{
              name: "Martins Wine Advisor",
              link: "/work/martinswine",
            }}
            prevProject={{
              name: "Sublime Comporta",
              link: "/work/sublimecomporta",
            }}
            selectedLanguage="pt"
          />
        </div>
      </div>
    </Layout>
  );
};

export default BestSeller;

export const BestSellerQuery = graphql`
  query BestSellerPhotosPt {
    allFile(
      filter: {
        extension: { regex: "/(jpg)|(jpeg)|(png)|(svg)/" }
        dir: { regex: "/static/img/projects/bestseller/" }
      }
      sort: { fields: name }
    ) {
      edges {
        node {
          id
          childImageSharp {
            fluid(maxWidth: 1400, quality: 100) {
              ...GatsbyImageSharpFluid_withWebp
            }
          }
        }
      }
    }
  }
`;
